import { createStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { compose } from 'recompose';
import { withBaseProps } from '../../Utils/Component';
const styles = (theme) => createStyles({
    triolietBackgroundContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'hidden',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: 0,
        margin: 0,
        position: 'relative',
        zIndex: 100,
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    topBar: {
        height: 40,
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        '&:before': {
            content: "''",
            position: 'absolute',
            background: 'white',
            width: '25%',
            height: 120,
            transform: 'skewX(-45deg)',
            zIndex: '-1',
        }
    },
    logo: {
        height: 50,
        width: '15%',
        objectFit: 'contain',
        marginTop: 30,
        marginLeft: '2.5%',
    },
});
const TriolietBackground = (props) => {
    const { classes, children, hideLogo, imagesBaseUrl } = props;
    const backgroundImage = {
        backgroundImage: `url(${imagesBaseUrl}/trioliet/assets/images/account/background.svg)`,
    };
    return (React.createElement("main", { className: classes.triolietBackgroundContainer, style: backgroundImage, "data-testid": 'trioliet-page' },
        !hideLogo && (React.createElement("div", { className: classes.topBar },
            React.createElement("img", { alt: 'trioliet', src: `${imagesBaseUrl}/trioliet/assets/images/common/logo/logo-rgb.png`, className: classes.logo }))),
        children));
};
export default compose(withBaseProps({ styles }))(TriolietBackground);
//# sourceMappingURL=TriolietBackground.js.map